import { Pane, spaces } from '@electricjs/arc';

const TablePaginationContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <Pane horizontal="center" py={spaces.space_m}>
      {children}
    </Pane>
  );
};

export default TablePaginationContainer;
